<template>
  <div id="app-wrapper">
    <Navigation class="navigationMenu"></Navigation>
    <main class="main">
      <provider-link></provider-link>
      <signup-modal></signup-modal>
      <login-modal></login-modal>
      <new-features-modal></new-features-modal>
      <subscription-modal></subscription-modal>
      <direct-link-modal></direct-link-modal>
      <payment-modal></payment-modal>
      <set-email-modal></set-email-modal>
      <set-user-type-modal></set-user-type-modal>
      <set-name-artist-modal></set-name-artist-modal>
      <login-unauthorized-user></login-unauthorized-user>
      <share-modal></share-modal>
      <buy-track-modal></buy-track-modal>
      <local-radio-modal></local-radio-modal>
      <credits-modal></credits-modal>
      <add-to-playlist/>
      <new-playlist/>
      <v-dialog/>
      <editor-ck/>
      <artist-profile v-show="isProfileOpen"></artist-profile>
      <playlist-profile v-show="isPlaylistOpen"></playlist-profile>
      <router-view></router-view>
    </main>
    <player></player>
  </div>
</template>

<script>
  import consts from '@/consts'
  import Navigation from '@/components/Navigation.vue'
  import Player from '@/components/player/Player.vue'
  import LoginModal from '@/components/modals/login/LoginModal.vue'
  import SignupModal from '@/components/modals/signup/SignupModal.vue'
  import SubscriptionModal from '@/components/modals/subscription/SubscriptionModal.vue'
  import PaymentModal from '@/components/modals/PaymentModal.vue'
  import ShareModal from '@/components/modals/ShareModal.vue'
  import BuyTrackModal from '@/components/modals/tracks/BuyTrackModal.vue'
  import CreditsModal from '@/components/modals/tracks/CreditsModal.vue'
  import ArtistProfile from '@/components/artistProfile/ArtistProfile.vue'
  import AddToPlaylist from '@/components/modals/playlist/AddToPlaylist.vue'
  import NewPlaylist from '@/components/modals/playlist/NewPlaylist.vue'
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import {mapActions, mapGetters} from 'vuex'
  import NewFeaturesModal from '@/components/modals/newFeaturesNotice/NewFeaturesModal.vue'
  import LocalRadioModal from './modals/LocalRadioModal.vue'
  import PlaylistProfile from '@/components/PlaylistProfile/PlaylistProfile.vue'
  import SetEmailModal from '@/components/modals/SetEmailModal.vue'
  import SetUserTypeModal from '@/components/modals/SetUserTypeModal.vue'
  import SetNameArtistModal from '@/components/modals/SetNameArtistModal.vue'
  import LoginUnauthorizedUser from '@/components/modals/login/LoginUnauthorizedUser.vue'
  import EditorCK from '@/components/textEditor/EditorCK.vue'

  export default {
    name: 'app-wrapper',
    components: {
      Navigation,
      Player,
      LoginModal,
      SignupModal,
      SubscriptionModal,
      PaymentModal,
      BuyTrackModal,
      ShareModal,
      ArtistProfile,
      AddToPlaylist,
      NewPlaylist,
      ProviderLink,
      DirectLinkModal,
      NewFeaturesModal,
      LocalRadioModal,
      PlaylistProfile,
      SetEmailModal,
      SetUserTypeModal,
      SetNameArtistModal,
      LoginUnauthorizedUser,
      CreditsModal,
      EditorCK
    },
    data () {
      return {
        checkedSeen: null,
        mk: false,
        fPixel: null,
        providerData: {
          provider: null,
          providerCountry: null
        }
      }
    },
    beforeRouteUpdate (to, from, next) {
      let matched = false
      for (const matchedRoute of to.matched) {
        if (matchedRoute.name === 'artist') {
          next(false)
          this.getArtist(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.getArtistTracks(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.getArtistPlaylists(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.openProfile()
          history.pushState({}, null, to.path)
          matched = true
        }

        if (matchedRoute.name === 'playlist') {
          next(false)
          this.getPlaylist(to.params.id).catch((e) => {
            this.$toasted.show(this.error.message, {type: 'error'})
          })
          this.openPlaylist()
          history.pushState({}, null, to.path)
          matched = true
        }
      }
      // close sidebar if route change
      if (!matched) {
        this.closeProfile()
        this.closePlaylist()
        next()
      }
    },
    beforeRouteEnter (to, from, next) {
      // Open sidebar if artist route is requested
      for (const matchedRoute of to.matched) {
        if (matchedRoute.name === 'artist') {
          next((vm) => {
            vm.$store.dispatch('artist/getArtist', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            vm.$store.dispatch('artist/getArtistTracks', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            vm.$store.dispatch('artist/getArtistPlaylists', to.params.id).catch((e) => {
              vm.$toasted.show(vm.getters['artist/error'].message, {type: 'error'})
            })
            if (vm.$store.getters['user/isLoggedIn']) {
              vm.$store.dispatch('user/getMyVotes').catch((e) => {
                vm.$toasted.show(vm.getters['user/error'].message, {type: 'error'})
              })
            }
            vm.$store.dispatch('artist/openProfile')
          })
        }
        if (matchedRoute.name === 'playlist') {
          next((vm) => {
            vm.$store.dispatch('playlist/getPlaylist', to.params.id).then(data => {
              let playlist = data.tracks
              if (playlist) {
                vm.$store.dispatch('player/setPlaylist', playlist)
                vm.$store.dispatch('player/playFirstTrack')
              }
            }).catch((e) => {
              vm.$toasted.show(vm.getters['playlist/error'].message, {type: 'error'})
            })
            vm.$store.dispatch('playlist/openPlaylist')
          })
        }
      }
      if (typeof to.query.login !== 'undefined') {
        next((vm) => {
          vm.$modal.show('login-modal')
        })
      } else if (typeof to.query.signup !== 'undefined') {
        next((vm) => {
          vm.$modal.show('signup-modal')
        })
      } else if (typeof to.query.subscription !== 'undefined') {
        next((vm) => {
          vm.$modal.show('subscription-modal')
        })
      } else if (typeof to.query.referredCode !== 'undefined') {
        next((vm) => {
          vm.$modal.show('subscription-modal')
        })
      } else if (typeof to.query.track_id !== 'undefined') {
        next((vm) => {
          vm.$http.get(consts.API_BASE_URL + `/tracks/get/${to.query.track_id}`).then(res => {
            let track = res.body.data[0]
            if (track.length) {
              vm.$store.dispatch('player/setPlaylist', track)
              vm.$store.dispatch('player/playFirstTrack')
            }
          })
        })
      } else if (typeof to.query.playlist_id !== 'undefined') {
        next((vm) => {
          vm.$http.get(consts.API_BASE_URL + `/playlists/getPlaylist/${to.query.playlist_id}`).then((res) => {
            let playlist = res.body.data.tracks
            if (playlist) {
              vm.$store.dispatch('player/setPlaylist', playlist)
              vm.$store.dispatch('player/playFirstTrack')
            }
          })
        })
      } else {
        next()
      }
    },
    methods: {
      ...mapActions('user', [
        'checkUser',
        'loginByMsisdn',
        'loginAuth',
        'getMyFollowedArtists',
        'setSubsReferredCodeAction',
        'checkMyActiveUserReferredPlan'
      ]),
      ...mapActions('artist', [
        'getArtist',
        'getArtistTracks',
        'getArtistPlaylists',
        'openProfile',
        'closeProfile'
      ]),
      ...mapActions('news', [
        'getNewsFeatures'
      ]),
      ...mapActions('playlist', [
        'getPlaylist',
        'openPlaylist',
        'closePlaylist'
      ]),
      ...mapActions('player', [
        'setPlaylist',
        'setPlaying',
        'changeTrack'
      ]),
      ...mapActions('pricing', [
        'getPricing'
      ]),
      ...mapActions('home', [
        'getProviders'
      ]),
      onpopstate (event) {
        // when the state is stored by `beforeRouteUpdate` event, the key is null
        if (this.isProfileOpen && event.state.key !== undefined) {
          this.closeProfile()
        }
      },
      checkUserLoguedIn () {
        let provider = localStorage.getItem('provider')
        if (!this.isLoggedIn && !provider) {
          this.$router.push({path: '/'})
        }
      },
      playTrack (track) {
        if (this.currentTrack !== track) {
          this.$emit('play')
          this.changeTrack(track)
        } else {
          this.setPlaying(true)
        }
      },
      setPlayer (track, playlist) {
        this.setPlaylist(playlist)
        this.playTrack(track)
      }
    },
    computed: {
      ...mapGetters('artist', [
        'isProfileOpen',
        'error'
      ]),
      ...mapGetters('user', [
        'isLoggedIn',
        'authToken',
        'msisdn',
        'provider',
        'user',
        'subsReferredCode'
      ]),
      ...mapGetters('news', [
        'news'
      ]),
      ...mapGetters('playlist', [
        'isPlaylistOpen'
      ]),
      ...mapGetters('translator', [
        'language'
      ]),
      ...mapGetters('player', [
        'isShareTrack',
        'currentTrack'
      ])
    },
    watch: {
      subsReferredCode: function (newSubsReferredCode, oldSubsReferredCode) {
        if (this.subsReferredCode && !this.user.subscription.active) {
          this.$modal.show('subscription-modal')
        }
      }
    },
    created () {
      this.checkUser().then(() => {
        let data = {'user': this.user.id, 'language': this.language}
        var that = this
        if (parseInt(that.user.user_type) === 3) {
          this.$modal.show('set-user-type-modal')
        } else {
          this.getNewsFeatures(data).then(() => {
            if (that.news.length !== 0) {
              that.$modal.show('new-features-modal')
            }
          })
          this.mk = localStorage.getItem('userFromLandingMK')
          if (this.$route.query.referredCode) {
            this.setSubsReferredCodeAction(this.$route.query.referredCode)
            localStorage.removeItem('referredCode')
          }
        }
      })
      this.getPricing()
      window.onpopstate = this.onpopstate
      this.fPixel = this.$route.query.payment
    },
    mounted () {
      this.providerData.provider = localStorage.getItem('provider')
      this.providerData.providerCountry = localStorage.getItem('providerCountry')
      this.getProviders(this.providerData)
      if (this.fPixel) {
        window.fbq('track', 'CompleteRegistration')
      }
      if (this.mk === true) {
        localStorage.removeItem('userFromLandingMK')
        console.log('aquí se debe ejecutar el pixel que confirma el éxito de la operación de marketing')
      }
      this.getMyFollowedArtists({getIds: true})
      this.checkMyActiveUserReferredPlan()
      if (!this.isShareTrack) setTimeout(this.checkUserLoguedIn, 15000)
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('../assets/fonts/TitilliumWeb-Bold.eot');
    src: url('../assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('../assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('../assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('../assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('../assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('../assets/fonts/TitilliumWeb-Regular.eot');
    src: url('../assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('../assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('../assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('../assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('../assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Gotham Black';
    src: url('../assets/fonts/GothamBlack.otf');
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: 'Gotham Medium';
    src: url('../assets/fonts/GothamMedium.ttf');
  }
  @font-face {
    font-family: 'Gotham Light';
    src: url('../assets/fonts/GothamLight.ttf');
  }

  .navigationMenu {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
  }

  .GothamBlack {
    font-family: 'Gotham Black';
  }
  .GothamMedium {
    font-family: 'Gotham Medium';
  }
  .GothamLight {
    font-family: 'Gotham Light';
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: $background-color;
    height: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
    background-color: $background-color;
    height: $main-height;
    width: 100vw;
  }

  .main {
    height: $main-height;
    width: 100vw;
    padding-top: 50px;
  }

  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .textColor {
    color: $text-color;
  }

  .iconColor {
    color: $icon-color;
  }

  .accent {
    color: $accent-color;
  }

  .errorText {
    color: $error-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
    background-color: $background-color;
    color: $text-color !important;
  }

  .error {
    border-bottom: 1px solid $error-color;
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  ::placeholder {
    color: $text-color !important;
  }

  .v--modal {
    background-color: $background-color !important;
  }

  @media (min-width: 320px) and (max-width: 500px ){
    .main{
      padding-top: 59px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppWrapper.vue